declare global {
  interface Window {
    gtag: any;
  }
}

export const events = {
  USER_LOGGED_OUT: 'User logged out',
  USER_LOGGED_IN: 'User logged in',
  USER_SIGNED_UP: 'User signed up',
};

export const identify = (user_id: string) => {
  if (typeof window !== 'undefined') window.gtag('set', { user_id });
};
// log specific events happening.
export const track = ({ action, params }: any) => {
  if (typeof window !== 'undefined') window.gtag('event', action, params);
};
